<template>
  <section class="all-cases-view" v-loading="loading">
    <div class="container-default">
      <div class="listings-navbar">
        <el-row>
          <el-col :lg="17">
            <ul class="d-flex list-items-group-15 conformation-csv">
              <li>
                <span class="csv-header" v-if="resultFileData">
                  {{ resultFileData.name }}
                  <el-tag class="case-type-tag">
                    {{ caseTypeMap[resultFileData.case_type] }}
                  </el-tag>
                  <el-tag
                    v-if="resultFileData.contains_other_case_type"
                    type="warning"
                    style="margin-left: 6px;"
                  >
                    + Other Case Types
                  </el-tag>
                </span>
              </li>
            </ul>
          </el-col>
          <el-col :lg="7" v-if="resultFileData">
            <ul
              class="d-flex justify-content-end list-items-group-15 conformation-csv"
            >
            <li class="csv-header" v-if="
                  (resultFileData.case_type == 'UTI' || resultFileData.case_type == 'STI' || resultFileData.case_type == 'WOMENS_HEALTH') && !resultFileData?.ark_Pharmacy_status">
                <el-button type="primary" @click="multiArSyncReort">
                  Bulk Sync Pharmacy Report
                  <el-icon>
                    <Promotion />
                  </el-icon>
                </el-button>
              </li>
               <li class="csv-header" v-else-if="
                  (resultFileData.case_type == 'UTI' || resultFileData.case_type == 'STI' || resultFileData.case_type == 'WOMENS_HEALTH') && resultFileData?.ark_Pharmacy_status">
                <el-tag :type="getStatusType(resultFileData?.ark_Pharmacy_status)">
                    {{ resultFileData?.ark_Pharmacy_status }}
                  </el-tag>
              </li>
              <!-- <li
                class="csv-header"
                v-if="
                  (resultFileData.case_type == 'UTI' ||
                    resultFileData.case_type == 'WOUND' ||
                    resultFileData.case_type == 'RESPIRATORY_PATHOGEN_PANEL') &&
                  hasPermission('cases', 'report_upload_new')
                "
              >
                <el-button
                  type="primary"
                  @click="setPharamacyReportStatus"
                  v-if="resultFileData.include_pharmacy_report == false"
                >
                  Send Results For Pharmacy Report
                  <el-icon>
                    <Promotion />
                  </el-icon>
                </el-button>
                <el-tag type="success" size="large" round v-else>
                  Results Ready For Pharamcy Report
                  <el-icon>
                    <Finished />
                  </el-icon>
                </el-tag>
              </li> -->
            </ul>
          </el-col>
        </el-row>
      </div>
      <div class="primary-content-view-new" v-if="resultFileData">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table
            :data="allSampleNamesData.data"
            @sort-change="onChangeSort"
            id="resultFilesTable"
            :row-class-name="currentActiveRowClassName"
            height="calc(-194px + 100vh)"
          >
            <el-table-column
              prop="sample_name"
              label="NAME"
              width="120"
              sortable="custom"
            >
              <template #default="scope">
                <div id="order-id">
                  <span>{{ scope.row.sample_name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="barcode_value"
              label="BARCODE"
              width="120"
              sortable="custom"
            >
              <template #default="scope">
                <div id="order-id">
                  <span>{{ scope.row.barcode_value || '' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="STATUS"
              width="120"
              prop="report_status"
              sortable="custom"
            >
              <template #default="scope">
                <div class="column-status">
                  <span class="el-dropdown-link">
                    <el-tag :type="getStatusType(scope.row.report_status)">
                      {{ scope.row.report_status }}
                    </el-tag>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="message"
              label="MESSAGE"
              min-width="125"
              max-width="250"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="scope.row.message"
                >
                  <span class="text-start" style="word-break: keep-all">
                    {{ scope.row.message }}
                  </span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="response_time"
              label="DATE"
              width="100"
              sortable="custom"
            >
              <template #default="scope">
                <div class="d-flex">
                  <div class="date pr-10">
                    {{
                      momentWithTimezone(scope.row.response_time, "MM-DD-yyyy")
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="COVID STATUS"
              prop="covid_status"
              sortable="custom"
              width="150"
              v-if="
                resultFileData.case_type == 'COVID' ||
                resultFileData.case_type == 'COVID_FLU'
              "
            >
              <template v-slot="scope">
                <div class="column-status" v-if="scope.row.covid_status">
                  <el-tag :type="getStatusType(scope.row.covid_status)">
                    {{ scope.row.covid_status }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="FINALIZED ON"
              width="100"
              prop="finalized_at"
            >
              <template #default="scope">
                <div v-if="scope.row.finalized_at" class="d-flex">
                  <div class="date pr-10">
                    {{
                      momentWithTimezone(scope.row.finalized_at, "MM-DD-yyyy")
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="finalized_by"
              label="FINALIZED BY"
              width="120"
            >
              <template #default="scope">
                <div v-if="scope.row.finalized_by">
                  <span class="text-center">
                    {{ scope.row.finalized_by.first_name }}
                    {{ scope.row.finalized_by.last_name }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Result Status"
              width="120"
              v-if="
                resultFileData.case_type == 'RESPIRATORY_PATHOGEN_PANEL' ||
                resultFileData.case_type == 'TOXICOLOGY' ||
                resultFileData.case_type == 'UTI' ||
                resultFileData.case_type == 'STI' ||
                resultFileData.case_type == 'WOMENS_HEALTH'
              "
            >
              <template #default="scope">
                <div class="column-status" v-if="scope.row.result_status">
                  <el-tag :type="getStatusType(scope.row.result_status)">
                    {{ scope.row.result_status }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="PR Status" width="120" v-if="
                resultFileData.case_type == 'RESPIRATORY_PATHOGEN_PANEL' ||
                resultFileData.case_type == 'TOXICOLOGY' ||
                resultFileData.case_type == 'UTI' || 
                resultFileData.case_type == 'STI' ||
                resultFileData.case_type == 'WOMENS_HEALTH'
              ">
              <template #default="scope">
                <div class="column-status" v-if="scope?.row?.result_status == 'POSITIVE' && scope?.row?.is_insource_arkstone_pharmacy_report">
                  <el-tag :type="getStatusType('COMPLETED')">
                    {{ "COMPLETED" }}
                  </el-tag>
                </div>
                <div class="column-status" v-else-if="scope?.row?.result_status == 'POSITIVE' && !scope?.row?.message && resultFileData?.ark_Pharmacy_status == 'PROCESSING'">
                  <el-tag :type="getStatusType('PROCESSING')">
                    {{ "PROCESSING" }}
                  </el-tag>
                </div>
                <div class="column-status" v-else-if="scope?.row?.result_status == 'POSITIVE' && (scope?.row?.message && scope?.row?.message?.toLowerCase() != 'invalid accession id' ||  (resultFileData?.ark_Pharmacy_status == 'COMPLETED' && !scope?.row?.is_insource_arkstone_pharmacy_report)) ">
                  <el-tag :type="getStatusType('FAILED')">
                    {{ "FAILED" }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column
              v-if="
                resultFileData.case_type == 'UTI' ||
                resultFileData.case_type == 'WOUND' ||
                resultFileData.case_type == 'RESPIRATORY_PATHOGEN_PANEL'
              "
              prop="pharmacy_report_sync_status"
              label="Send Pharamacy Order"
              width="180"
            >
              <template
                #default="scope"
                v-if="resultFileData.include_pharmacy_report == true"
              >
                <div
                  v-if="scope.row.pharmacy_report_order_status == 'TO-START'"
                >
                  <el-button
                    type="text"
                    class="view-progress-btn"
                    @click="sendPharmacyOrder(scope.row)"
                    >Send Order</el-button
                  >
                </div>
                <div
                  v-else-if="scope.row.pharmacy_report_order_status == 'FAILED'"
                >
                  <el-tooltip
                    :content="scope.row.pharmacy_report_order_status"
                    placement="top"
                    effect="dark"
                  >
                    <el-button
                      type="text"
                      class="view-progress-btn"
                      @click="sendPharmacyOrder(scope.row)"
                      >Re-send</el-button
                    >
                  </el-tooltip>
                </div>
                <div v-else class="column-status">
                  <el-tag
                    :type="
                      getStatusType(scope.row.pharmacy_report_order_status)
                    "
                    >{{ scope.row.pharmacy_report_order_status }}</el-tag
                  >
                </div>
              </template>
            </el-table-column> -->
            <!-- <el-table-column
              v-if="
                resultFileData.case_type == 'UTI' ||
                resultFileData.case_type == 'WOUND' ||
                resultFileData.case_type == 'RESPIRATORY_PATHOGEN_PANEL'
              "
              prop="pharmacy_report_sync_status"
              label="Sync Report"
              width="150"
            >
              <template
                #default="scope"
                v-if="resultFileData.include_pharmacy_report == true"
              >
                <div
                  v-if="scope.row.pharmacy_report_order_status == 'COMPLETED'"
                >
                  <div
                    v-if="scope.row.pharmacy_report_sync_status == 'TO-START'"
                  >
                    <el-button
                      type="text"
                      class="view-progress-btn"
                      @click="syncPharamcyReport(scope.row)"
                      >Sync report</el-button
                    >
                  </div>
                  <div
                    v-else-if="
                      scope.row.pharmacy_report_sync_status == 'FAILED'
                    "
                  >
                    <el-button
                      type="text"
                      class="view-progress-btn"
                      @click="syncPharamcyReport(scope.row)"
                      >Resync report</el-button
                    >
                  </div>
                  <div v-else class="column-status">
                    <el-tag
                      :type="
                        getStatusType(scope.row.pharmacy_report_sync_status)
                      "
                      >{{ scope.row.pharmacy_report_sync_status }}</el-tag
                    >
                  </div>
                </div>
                <div v-else class="column-status">
                  <el-tag
                    :type="getStatusType(scope.row.pharmacy_report_sync_status)"
                    >{{ scope.row.pharmacy_report_sync_status }}</el-tag
                  >
                </div>
              </template>
            </el-table-column> -->
            <el-table-column
              prop="action"
              fixed="right"
              label="Actions"
              width="260"
            >
              <template #default="scope">
                <ul class="listings__action-buttons">
                  <li
                    v-if="
                      scope.row.report_status != 'FAILED' &&
                      scope.row.report_status != 'TO-START'
                    "
                  >
                    <el-button
                      class="view-button"
                      @click="onUTIDownloadReport(scope.row)"
                      v-if="
                        (resultFileData.case_type == 'UTI' ||
                          resultFileData.case_type == 'WOUND' ||
                          resultFileData.case_type ==
                            'RESPIRATORY_PATHOGEN_PANEL') &&
                        scope.row.pharmacy_report_merged_report_path &&
                        scope.row.download_ready
                      "
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/download-new-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/download-new.svg"
                        alt="icon"
                      />
                    </el-button>
                    <el-button
                      class="view-button"
                      @click="onDownloadReport(scope.row)"
                      v-else
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/download-new-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/download-new.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>

                  <li
                    v-if="
                      scope.row.report_status != 'FAILED' &&
                      scope.row.report_status != 'TO-START'
                    "
                  >
                    <el-button
                      class="view-button"
                      @click="viewReport(scope.row)"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.case_type == 'UTI' &&
                      scope.row.report_status == 'COMPLETED'
                    "
                  >
                    <el-button
                      class="discrete-results-btn"
                      @click="downloadDiscreteResults(scope.row)"
                      title="EXPORT DISCRETE RESULTS"
                    >
                      DR
                    </el-button>
                  </li>
                  <li v-if="
                      (scope.row.case_type == 'UTI' ||
                      scope.row.case_type == 'WOMENS_HEALTH' ||
                      scope.row.case_type == 'STI')">
                    <el-button
                      class="discrete-results-btn"
                      @click="generateArkReport(scope.row, false)"
                      title="GENERATE ARKSTONE REPORT"
                    >
                    AR
                    </el-button>
                  </li>
                  <!-- <li v-if="(isSuperAdmin || isLabTechnologistUser || isLabManager) &&
                      (scope.row.case_type == 'UTI' ||
                      scope.row.case_type == 'WOUND' ||
                      scope.row.case_type == 'RESPIRATORY_PATHOGEN_PANEL')"
                  >
                    <el-button
                      class="discrete-results-btn"
                      @click="generateArkReport(scope.row, true)"
                      title="GENERATE ARKSTONE REPORT"
                    >
                    LAR
                    </el-button>
                  </li> -->
                  <li
                    v-if="
                      resultFileData.case_type.toLowerCase() == 'toxicology' &&
                      scope.row.report_status != 'FAILED' &&
                      scope.row.report_status != 'TO-START' &&
                      hasPermission('cases', 'report_upload_new')
                    "
                  >
                    <el-button
                      @click="onReportEdit(scope.row)"
                      :disabled="scope.row.is_finalized"
                      :title="
                        scope.row.is_finalized
                          ? 'This case is already finalized'
                          : 'Edit Report'
                      "
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/edit-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/edit-deactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li v-if="scope.row.report_status == 'FAILED'">
                    <el-button
                      class="view-button"
                      @click="regenerateFailedReport(scope.row)"
                    >
                      <img
                        src="@/assets/images/icons/actions/restore-icon.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.report_status == 'COMPLETED' &&
                      !scope.row.is_finalized &&
                      hasPermission('cases', 'report_upload_new')
                    "
                  >
                    <el-button
                      class="finalize-btn"
                      @click="finalizeReport(scope.row)"
                      :disabled="
                        scope.row.case_type != 'TOXICOLOGY' &&
                        hasPermission('cases', 'report_upload_new')
                      "
                      >Finalize</el-button
                    >
                  </li>

                  <li
                    class="d-flex align-center"
                    v-if="scope.row.is_finalized == true"
                  >
                    <el-button class="finalized-btn">Finalized</el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.case_type != 'UTI' &&
                      scope.row.case_type != 'WOUND' &&
                      scope.row.case_type != 'RESPIRATORY_PATHOGEN_PANEL'
                    "
                  >
                    <el-button
                      class="delete-button"
                      @click="downloadCsvReport(scope.row)"
                    >
                      <img
                        src="@/assets/images/icons/actions/csv-file-icon.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="listings listings__pagination">
          <el-pagination
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[10, 25, 50, 100]"
            layout=" prev, pager, next, jumper, sizes ,total"
            :total="allSampleNamesData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseConstants from "@/config/constants/caseConstants";
import FileDownloadHelper from "@/mixins/FileDownloadHelper";
import FilterHelper from "@/mixins/FilterHelper";
import GlobalHelper from "@/mixins/GlobalHelper";

import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  mixins: [
    UserPermissionsHelper,
    FileDownloadHelper,
    FilterHelper,
    GlobalHelper,
  ],
  computed: {
    ...mapGetters("respiratoryFileUpload", [
      "getUploadedDocumentDetails",
      "getGenerateReportStatus",
      "getGeneratedReportsFromFileUploads",
      "getGenerateFailedReportStatus",
      "getSelectedResultFileData",
      "getCovidStatusUpdated",
      "getCovidStatusUpdateError",
      "getFileDownloadUrl",
      "getSampleNameTestResultData",
      "getEditReportAccess",
      "getReportEditBlockingReason",
    ]),
    ...mapGetters("emrOrders", [
      "getSendReportStatus",
      "getEmrUniBiDirectionalStatus",
      "getSendAthenaEMRDiscreteResultsStatus",
    ]),
    ...mapGetters("cases", [
      "getReportGenerateStatus",
      "getTestReportURL",
      "getFaxSentStatus",
      "getReportSentToPatientStatus",
      "getReportSentToPatientBySMSStatus",
      "getDownloadReportData",
    ]),
    ...mapGetters("auth", ["getAuthenticationDetails"]),
    ...mapGetters("errors", ["getError"]),
    ...mapGetters("resultFiles", [
      "getPharamcyReportSentStatus",
      "getPharmacyOrderSentStatus",
      "getPharmacySyncStatus",
      "getdownloadDiscreteResultsStatus",
      "getMultiPharamacyArkstone",
    ]),
    getStatusType() {
      return (status) => {
        if (status == "POSITIVE") {
          return "danger";
        } else if (status == "NEGATIVE") {
          return "success";
        }
        if (status == "FAILED") {
          return "danger";
        } else if (status == "COMPLETED") {
          return "success";
        }
        if (status == "INCONSISTENT") {
          return "warning";
        } else if (status == "CONSISTENT") {
          return "success";
        }
        if (status == "PROCESSING") {
          return "warning";
        } else {
          return "";
        }
      };
    },
    resultFileId() {
      return this.$route.params.result_file_id;
    },
  },
  async mounted() {
    this.setQueryParams();
    await this.fetchFileReportStatusData();
  },
  data() {
    return {
      page: 1,
      loading: false,
      files: {},
      dialogVisible: false,
      selectedCaseId: null,
      exportDialogVisisble: false,
      fieldList: [],
      date_type: "collection_date",
      pageSize: 10,
      generatedReportsTableDialog: false,
      btnLoading: false,
      result_file_id: "",
      resultFileData: null,
      statuses: ["TO-START", "PROCESSING", "FAILED", "COMPLETED"],
      selectedStatus: "",
      allSampleNames: [],
      allSampleNamesData: {
        data: [],
        page: 1,
        total: 0,
      },
      refresh: false,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      loadingText: "Fetching Data....",
      orderBy: "",
      orderType: "",
      reportData: null,
      finalizedAccession: "",
      finalizedCaseData: null,
    };
  },
  props: {
    selectedStatuses: {
      default: [],
    },
  },
  methods: {
    async downloadDiscreteResults(report) {
      try {
        this.loading = true;
        let params = {
          result_file_id: this.resultFileId,
          report_id: report._id,
          test_results_id: report.test_results_id,
        };
        await this.$store.dispatch("resultFiles/downloadDiscreteData", params);
        if (this.getdownloadDiscreteResultsStatus) {
          const url = window.URL.createObjectURL(
            new Blob([this.getdownloadDiscreteResultsStatus])
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${report.sample_name}.csv`); //or any other extension
          document.body.appendChild(link);
          link.click();
          successNotification("Discrete Results downloaded successfully");
        } else {
          errorNotification("Error while downloading Discrete Results");
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async onReportEdit(data) {
      this.loading = true;
      this.loadingText = "Checking edit status";
      let enabled = await this.checkEditEanbled(data);
      this.loading = false;

      if (!enabled) {
        this.$alert(
          this.getReportEditBlockingReason ||
            "Case reports already finalized you cannot edit any report",
          "Warning",
          {
            confirmButtonText: "OK",
          }
        );
        return;
      }

      let routerData = this.$router.resolve({
        name: "toxicology-test-results",
        params: {
          result_file_id: this.resultFileId,
          report_id: data._id,
          test_results_id: data.test_results_id,
        },
      });
      window.location.href = routerData.href;
    },
    async checkEditEanbled(data) {
      try {
        if (data.is_finalized) return false;
        let params = {
          sample_name_id: data._id,
        };
        await this.$store.dispatch(
          "respiratoryFileUpload/checkReportEditStatus",
          params
        );
        if (this.getEditReportAccess) {
          return true;
        } else {
          return false;
        }
      } catch (err) {
        this.$notify.error({
          title: "Error",
          message: "Error on generating test report",
        });
      }
    },
    async regenerateFailedReport(report) {
      let params = {
        result_file_id: this.resultFileId,
        sample_name_id: report._id,
      };
      this.btnLoading = true;
      this.loading = true;
      await this.$store.dispatch(
        "respiratoryFileUpload/regenerateFailedReportsFromFileUploads",
        params
      );
      this.loading = false;
      this.btnLoading = false;
      if (
        this.getGenerateFailedReportStatus &&
        this.getGenerateFailedReportStatus.success
      ) {
        successNotification(this.getGenerateFailedReportStatus.message);

        this.finalizedAccession = report.sample_name;
        this.updateQueryParamsData();
        window.location.reload();
      } else {
        errorNotification("Error while creating report generation");
      }
    },
    async setPharamacyReportStatus() {
      try {
        this.loading = true;
        let params = {
          id: this.$route.params.result_file_id,
        };
        await this.$store.dispatch(
          "resultFiles/setPharamcyReportStatus",
          params
        );
        if (this.getPharamcyReportSentStatus) {
          successNotification(
            "Result file pharmacy report status updated  successfully"
          );
          setTimeout(() => {
            window.location.reload();
          }, 100);
        } else {
          errorNotification(this.getError || "Error while updating status");
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async syncPharamcyReport(data) {
      try {
        this.loading = true;
        let params = {
          id: this.$route.params.result_file_id,
          report_id: data._id,
        };
        await this.$store.dispatch("resultFiles/syncPharamacyReports", params);
        if (this.getPharmacySyncStatus) {
          successNotification("Reports sync successfully");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          errorNotification(this.getError || "Error while sync reports");
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async sendPharmacyOrder(data) {
      try {
        this.loading = true;
        let params = {
          id: this.$route.params.result_file_id,
          report_id: data._id,
        };
        await this.$store.dispatch("resultFiles/sendPharamacyOrder", params);
        if (this.getPharmacyOrderSentStatus) {
          successNotification(
            "Pharmacy order sending process started successfully"
          );
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          errorNotification(this.getError || "Error while sending order");
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async fetchFileReportStatusData() {
      this.loading = true;
      let params = {
        id: this.resultFileId,
        limit: this.pageSize,
        page: this.page,
      };

      if (this.orderBy && this.order_type) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType === "ascending" ? "asc" : "desc";
      }

      if (this.selectedStatuses) {
        params.report_status = this.selectedStatuses;
      }

      await this.$store.dispatch(
        "respiratoryFileUpload/fetchGeneratedReportsFromFileUploads",
        params
      );

      this.resultFileData = this.getSelectedResultFileData;
      this.allSampleNamesData = this.getGeneratedReportsFromFileUploads;
      await this.updateQueryParamsData();

      const tableElement = document.getElementById("resultFilesTable");

      if (tableElement) {
        const activeRow = tableElement.getElementsByClassName(
          "active-finalize-row"
        )[0];
        if (activeRow) {
          activeRow.scrollIntoView({ block: "center" });
        }
      }

      this.loading = false;
    },
    async updateQueryParamsData() {
      let params = {
        selectedResultDetailsPage: this.page,
        selectedResultDetailsPageSize: this.pageSize,
        selectedResultDetailsReportStatus: this.selectedStatus,
        finalizedAccession: this.finalizedAccession,
      };
      params = { ...this.$route.query, ...params };
      await this.updateQueryParam(this.$route.name, params);
    },
    setQueryParams() {
      this.page = parseInt(this.$route.query.selectedResultDetailsPage) || 1;
      this.pageSize =
        parseInt(this.$route.query.selectedResultDetailsPageSize) || 10;
      this.selectedStatus = this.$route.query.selectedResultDetailsReportStatus;
      this.finalizedAccession = this.$route.query.finalizedAccession;
    },
    async viewReport(report) {
      this.loading = true;
      await this.generateReport(report, true, false);
      try {
        let routerData = this.$router.resolve({
          name: "ResultFileReport",
          params: {
            result_file_id: this.resultFileId,
            report_id: report._id,
            test_results_id: report.test_results_id,
          },
        });
        window.open(routerData.href, "_blank");
      } catch (err) {
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async onUTIDownloadReport(report) {
      this.loading = true;
      this.loadingText = "Downloading Report....";
      let source = report.pharmacy_report_merged_report_path;
      await this.$store.dispatch("cases/fetchTestReportDownloadURL", {
        path: source,
      });

      let url = this.getDownloadReportData.data.download_url;
      window.open(url, "_blank");
      this.loading = false;
    },
    async onDownloadReport(report) {
      this.loading = true;
      this.loadingText = "Downloading Report....";

      if (report.download_ready) {
        await this.generateReport(report);
      } else {
        await this.generateReport(report);
      }
      this.loading = false;
    },
    async generateReportWhileFinalizing(report) {
      try {
        await this.$store.dispatch("cases/generateTestReport", {
          case_id: report.sample_name,
          accession_id: report.sample_name,
          case_type: report.case_type,
          report_id: report._id,
          test_results_id: report.test_results_id,
          result_file_id: this.resultFileId,
          skip_download: true,
        });
      } catch (err) {
        console.log(err);
      }
    },
    async multiArSyncReort(){
      try{
        this.loading = true;
        this.loadingText = "Syncing Arkstone Reports....";
        let params = {
          id: this.$route.params.result_file_id,
        };
        await this.$store.dispatch("resultFiles/multiArSyncReort", params);
        if (this.getMultiPharamacyArkstone) {
          successNotification("Arkstone Reports Synced Successfully");
          await this.fetchFileReportStatusData();
        } else {
          errorNotification(this.getError || "Error while syncing reports");
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async generateArkReport(report, isLow = false) {
      this.loading = true;
      this.loadingText = "Generating Report....";
      const params = {
        id: this.$route.params.result_file_id,
        report_id: report._id,
        isLow : isLow
      };
      try {
        let htmlContent = null;
        // Case 1: SaveLabArkStone
        if (!report?.ark_pharmacy_report_result_id||!report?.is_insource_arkstone_pharmacy_report) {
          htmlContent = await this.$store.dispatch("resultFiles/SaveLabArkStone", params);
          if (!htmlContent) {
            this.$alert(
              "For this file, the report is not generated.",
              "Report Generation Failed",
              {
                confirmButtonText: "OK",
                type: "error",
              }
            );
            this.fetchFileReportStatusData();
            return;
          }
          await this.viewReport(report);
          await this.fetchFileReportStatusData();
          return;
        }
        await this.viewReport(report)
        return;
      } catch (error) {
        console.error("Error generating report:", error);
        this.fetchFileReportStatusData();
        this.$alert(
          error,
          "Report Generation Failed",
          {
            confirmButtonText: "OK",
            type: "error",
          }
        );
      } finally {
        this.loading = false;
      }
    },
    async generateReport(report, skipDownload = false, showSuccess = true) {
      try {
        await this.$store.dispatch("cases/generateTestReport", {
          case_id: report.sample_name,
          accession_id: report.sample_name,
          case_type: report.case_type,
          report_id: report._id,
          test_results_id: report.test_results_id,
          result_file_id: this.resultFileId,
          skip_download: skipDownload,
        });

        if (this.getReportGenerateStatus && showSuccess) {
          successNotification("Test Report Downloaded Successfully");
          await this.fetchFileReportStatusData();
        } else if (!this.getReportGenerateStatus) {
          errorNotification(
            this.getError || "Error while downloading test report"
          );
        }
      } catch (err) {
        console.log(err);
      }
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchFileReportStatusData();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchFileReportStatusData();
    },
    async downloadCsvReport(report) {
      let params = {
        result_file_id: this.resultFileId,
        sample_name_id: report._id,
        test_result_id: report.test_results_id,
        sample_name: report.sample_name,
      };

      await this.$store.dispatch(
        "respiratoryFileUpload/downloadReportCsvData",
        params
      );
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
    },
    async finalizeReport(data) {
      this.loading = true;
      const caseTypes = ["UTI", "STI", "WOMENS_HEALTH"];
      this.selectedFinalizedReport = null;
      let params = this.prepareParams(data);
      this.finalizedAccession = data.sample_name;
      if (caseTypes.includes(data?.case_type) && data?.result_status == "POSITIVE") {
        if (!data?.is_insource_arkstone_pharmacy_report && !data?.no_high_detected_organisms) {
          errorNotification("Please generate Pharmacy report before finalizing.");
          this.$alert(
            "Please generate Pharmacy report before finalizing.",
            "Error in Finalizing Report",
            {
              confirmButtonText: "OK",
              type: "error",
            }
          );
          this.loading = false;
          return;
        }
      }
      await this.$store.dispatch(
        "respiratoryFileUpload/updateCovidStatus",
        params
      );
      if (this.getCovidStatusUpdated && this.getCovidStatusUpdated.success) {
        successNotification("Test Report Finalized!");
        await this.updateQueryParamsData();
        await this.fetchFileReportStatusData();
        this.loading = false;
      } else {
        this.loading = false;
        errorNotification(
          this.getError ||
            this.getCovidStatusUpdateError ||
            "Status Not Updated"
        );
        await this.fetchFileReportStatusData();
      }
    },
    prepareParams(data) {
      let params = {
        result_file_id: this.resultFileId,
        sample_name_id: data._id,
        test_result_id: data.test_results_id,
        sample_name: data.sample_name,
      };

      if (data.covid_status) {
        params.covid_status = data.covid_status;
      }
      params.report_status = this.selectedStatuses;

      return params;
    },
    currentActiveRowClassName({ row }) {
      if (
        this.$route.query &&
        this.$route.query.finalizedAccession &&
        row.sample_name == this.$route.query.finalizedAccession
      ) {
        return "active-finalize-row";
      }
    },
  },
};
</script>
